var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "event-details-box event-box-shadow p-24" }, [
    _c("div", { staticClass: "event-registration-box event-box-shadow" }, [
      _c("div", { staticClass: "event-rg-section" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", [
          _c("h6", [_vm._v(_vm._s(_vm.headerLabel))]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(_vm.labels["ticket-label-already-registered-description"])
            ),
          ]),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "btn btn-primary", on: { click: _vm.reloadPage } },
            [_vm._v(_vm._s(_vm.labels["ticket-label-register-someone-else"]))]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "event-rg-avatar" }, [
      _c("div", { staticClass: "event-rg-bg" }),
      _vm._v(" "),
      _c("div", { staticClass: "event-rg-img font-light" }, [
        _c("img", {
          attrs: { src: require("../../assets/icons/info-icon.svg") },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }